import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { PublicLayout } from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Cercle from "@/pages/Cercle";
import YouTubePage from "@/pages/YouTubePage";
import Contact from "@/pages/Contact";
import Books from "@/pages/Books";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function AdminGate() {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-[#08080A] flex items-center justify-center text-amber-300">Chargement…</div>;
  return user ? <AdminDashboard /> : <AdminLogin />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <Toaster position="bottom-right" theme="dark" richColors />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/le-cercle" element={<Cercle />} />
                <Route path="/youtube" element={<YouTubePage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/livres" element={<Books />} />
              </Route>
              <Route path="/admin" element={<AdminGate />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
